<template>
      <ContactComponent />
  </template>
  
  <script>
  import ContactComponent from '@/components/ContactComponent.vue';
  
  export default {
    components: {
        ContactComponent
    }
  }
  </script>
  